import { render } from "./MainFooter.vue?vue&type=template&id=8df88f8c&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=8df88f8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df88f8c"]])

export default __exports__